import { configureStore } from '@reduxjs/toolkit'
import authReducer from './slices/authSlice'
import locationsReducer from './slices/locationsSlice'
import devicesReducer from './slices/devicesSlice'
import alertsReducer from './slices/alertsSlice'
import alertRulesReducer from './slices/alertRulesSlice'
import inspectionsReducer from './slices/inspectionsSlice'
import checklistsReducer from './slices/checklistsSlice'
import dashboardsReducer from './slices/dashboardsSlice'
import groupsReducer from './slices/groupsSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    locations: locationsReducer,
    devices: devicesReducer,
    alerts: alertsReducer,
    alertRules: alertRulesReducer,
    inspections: inspectionsReducer,
    checklists: checklistsReducer,
    dashboards: dashboardsReducer,
    groups: groupsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
  devTools: true,
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
